import Colors from '@omni/kit/theming/Colors';
import React from 'react';
import { View } from 'react-native';

export default function EmptyScreen(): JSX.Element {
  return <View style={{ flex: 1, backgroundColor: Colors.N0 }} />;
}
